// extracted by mini-css-extract-plugin
export var circle1 = "AboutUsLogo-module--circle1--6peZq";
export var container = "AboutUsLogo-module--container--eFyDz";
export var firstP = "AboutUsLogo-module--first-p--HONvG";
export var imageWrapper = "AboutUsLogo-module--image-wrapper--2TFIB";
export var img = "AboutUsLogo-module--img--4WnR8";
export var secondP = "AboutUsLogo-module--second-p--jqQoc";
export var thirdP = "AboutUsLogo-module--third-p---HlPx";
export var wrapper = "AboutUsLogo-module--wrapper--enbOX";